<div class="cropper-page">
  <!--  <div class="layout">-->
  <div class="canvas-block">
    <canvas
      #mainCanvas
      class="main-canvas"
      (mousedown)="onCanvasMouseDown($event)"
      (mousemove)="onCanvasMouseMove($event)"
      (mouseup)="onCanvasMouseUp()"
      (mouseleave)="onCanvasMouseLeave()"
    ></canvas>
  </div>

  <div class="preview-block">
    <div class="preview">
      <div class="preview-title">Preview</div>
      <canvas #previewCanvas class="preview-canvas"></canvas>
    </div>

    @if (this.imageLoaded) {
      <div class="toolbar">
        <div class="dimension">Original: X: {{ imageX }}px. Y: {{ imageY }}px.</div>
        <!--      <div class="dimension">Cropped: X: {{ outputX }}px. Y: {{ outputY }}px.</div>-->
        <br />
        <nz-upload
          (nzChange)="onFileSelected($any($event))"
          [nzShowUploadList]="false"
          nzAccept="image/*"
        >
          <button nz-button>
            <i nz-icon nzType="upload"></i>
            Change Image
          </button>
        </nz-upload>

        <!--      <div class="ratios">-->
        <!--        <button nz-button-->
        <!--                *ngFor="let ratio of ratios"-->
        <!--                [nzType]="(selectedRatio === ratio.label) ? 'primary' : 'default'"-->
        <!--                (click)="onRatioChange(ratio.label)">-->
        <!--          {{ ratio.label }}-->
        <!--        </button>-->
        <!--      </div>-->

        <!--      <button nz-button nzType="default" (click)="downloadCroppedImage()" [disabled]="!imageLoaded">-->
        <!--        <i nz-icon nzType="download"></i>-->
        <!--        Download Cropped Image-->
        <!--      </button>-->
      </div>
    }
  </div>
  <!--  </div>-->
</div>
